/* eslint-disable  jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */

import MaterialCheckbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'
import { Help } from '@material-ui/icons'
import cn from 'classnames'
import React from 'react'

import Tooltip from '../Tooltip'

const styles = theme => ({
  wrapper: {
    display: 'block',
    fontWeight: '400',
    '&.noPadding label > span': {
      width: '24px',
      height: '24px',
    },
    '&.bottom-border': {
      borderBottom: theme.borders.default,
    },
  },
  checkbox: {
    width: '36px',
    height: '36px',
    padding: '0 !important',
    '&.Mui-disabled': {
      color: `${`var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`} !important`,
      '& > span > div': {
        backgroundColor: `${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`} !important`,
      },
    },
  },
  customBox: {
    width: '18px',
    height: '18px',
    backgroundColor: `var(--gameday-muiStyles-checkboxBg, ${theme.muiStyles.checkboxBg})`,
    border: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    borderRadius: '2px',
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 0,
    '& > span:hover, & > span.Mui-checked:hover': {
      background: 'none',
    },
    '&.right': {
      alignItems: 'center',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
    },
    '&.top': {
      flexDirection: 'column',
      '& > span': {
        width: '20px',
        padding: 0,
      },
    },
    '&.bottom': {
      flexDirection: 'column-reverse',
      '& > span': {
        width: '20px',
        padding: 0,
      },
    },
    '&.left': {
      '& .unChecked': {
        margin: '3px',
      },
      '@media (min-width: 600px)': {
        flexDirection: 'row',
        alignItems: 'center',
        '& > div': {
          flexGrow: 1,
        },
        '& > span': {
          justifyContent: 'flex-start',
          flexGrow: 4,
          '& > span:last-child': {
            width: '48px',
            // marginLeft: '-10px'
          },
        },
      },
      '@media (max-width: 599px)': {
        '& > span': {
          width: '20px',
        },
      },
    },
  },
  labelText: {
    marginLeft: 8,
    fontSize: theme.typography.fontSizeSmaller,
    wordWrap: 'break-word',
    textAlign: 'left',
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    '& .required': {
      marginLeft: '0.25rem',
      color: theme.status.errorColor,
    },
  },
  helpText: {
    marginLeft: 8,
    marginRight: 8,
    '& > svg': {
      fontSize: 16,
      fill: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    },
  },
})

class Checkbox extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { isChecked: props.isChecked }
    this.onChecked = this.onChecked.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const { isChecked } = this.state
    if (nextProps.isChecked !== isChecked) {
      this.setState({ isChecked: nextProps.isChecked })
    }
  }

  onChecked(isChecked) {
    const { onChecked } = this.props
    this.setState({ isChecked }, () => {
      onChecked(isChecked)
    })
  }

  render() {
    const {
      label,
      type,
      isDisabled,
      labelPlacement,
      bottomBorder,
      onChecked,
      isRequired,
      noPadding,
      classes,
      customMargin,
      helpText,
      id,
      labelIsTrigger,
      ...rest
    } = this.props

    const { isChecked } = this.state

    const helpTextComponent = helpText ? (
      <span className={classes.helpText}>
        <Tooltip content={helpText} placement="top">
          <Help className={classes.icon} />
        </Tooltip>
      </span>
    ) : null

    return (
      <span
        className={cn(classes.wrapper, {
          'bottom-border': bottomBorder,
          noPadding,
        })}
        style={{ margin: customMargin }}
      >
        {!label ? (
          <MaterialCheckbox
            color={type}
            disabled={isDisabled}
            checked={isChecked}
            // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
            onChange={(event, value) => {
              this.onChecked(value)
            }}
            icon={<div className={cn(classes.customBox, 'unChecked')} />}
            classes={{ root: classes.checkbox }}
            {...rest}
          />
        ) : (
          // biome-ignore lint/a11y/useKeyWithClickEvents: TODO
          <label
            className={cn(classes.label, labelPlacement)}
            htmlFor={id}
            onClick={() => {
              labelIsTrigger && this.onChecked(isChecked)
            }}
          >
            {labelPlacement === 'right' && helpTextComponent}
            <div className={classes.labelText}>
              {label}
              {isRequired && <span className="required">*</span>}
              {(labelPlacement === 'top' || labelPlacement === 'bottom') && helpTextComponent}
            </div>
            {labelPlacement === 'left' && helpTextComponent}
            <MaterialCheckbox
              id={id}
              color={type}
              disabled={isDisabled}
              checked={isChecked}
              // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
              onChange={(event, value) => {
                this.onChecked(value)
              }}
              icon={<div className={cn(classes.customBox, 'unChecked')} />}
              classes={{ root: classes.checkbox }}
              {...rest}
            />
          </label>
        )}
      </span>
    )
  }
}

Checkbox.defaultProps = {
  isDisabled: false,
  isChecked: false,
  className: '',
  bottomBorder: false,
  type: 'primary',
  onChecked: f => f,
  labelPlacement: 'right',
  isRequired: false,
  noPadding: false,
}

const CheckboxComponent = withStyles(styles)(Checkbox)
CheckboxComponent.displayName = 'Checkbox'
export default CheckboxComponent
